// HELPERS
import {createClassName} from "@helpers/utils";
import React from "react";

import ContentBox from "@components/ContentBox/ContentBox";
import DefaultFields from "../../../components/DefaultFields/DefaultFields";
import fulfillment from "./Recap.fulfillment";
import TextView from "../../../../../components/TextView/TextView.jsx";
import OptionsList from "../../../components/OptionsList/OptionsList.jsx";
import Button from "../../../../../components/Button/Button.jsx";
import api from "@helpers/api";
import ActivityIndicator from "../../../../../components/ActivityIndicator/ActivityIndicator.jsx";

export default class Recap extends React.PureComponent
{
	state = _getInitialState.call(this);
	fields = _getFields.call(this);

	isFulfilled(state)
	{
		return fulfillment(state, this.state);
	}

	setCustomerState(customerState, callbackFn)
	{
		customerState = {...this.state.customerState, ...customerState};
		this.setState({
			customerState,
			isFulfilled: this.isFulfilled({customerState})
		}, () =>
		{
			this.props.setAppState({viewFulfilled: this.state.isFulfilled});
			if (callbackFn)
			{
				callbackFn();
			}
		});
	}

	componentDidMount()
	{
		const {props} = this;
		const {setAppState} = props;

		// Set navigation events
		setAppState({
			viewFulfilled: this.isFulfilled(),
			showValidationWarning: false,
			navigationButtons: {
				sharing: {},
				back: {},
				next: {
					onClick: () =>
					{
						if (this.state.isFulfilled === true)
						{
							return;
						}

						this.setState({hasFormValidationErrors: true});
						return setAppState({
							showValidationWarning: true
						});
					}
				}
			}
		});
	}

	render()
	{
		const {customerState, readOnly} = this.state;
		const hasFormValidationErrors = !this.state.isFulfilled && this.state.hasFormValidationErrors;
		const classes = createClassName("Cob-view Cob-view2", {});

		return (
			<div className={classes}>
				<DefaultFields fields={this.fields}/>

				<ContentBox>
					<h2>Recap</h2>

					<div className="Cob-view2-fields">
						<p className={"field-label initial"}>
							Summera de mest relevanta behoven du har identifierat där vi kan bli bättre för kunden.
							Fokusera på högst tre sådana behov. Om du har en idé om en möjlig kapitalvolym, dela gärna
							med dig av den.
						</p>

						<TextView
							name="customer_recap_relevant_needs"
							label={`Fritext (${1800 - customerState.customer_recap_relevant_needs.length} tecken kvar)`}
							value={customerState.customer_recap_relevant_needs}
							maxLength={1800}
							validation={value => value.length > 0}
							resize="vertical"
							onChange={({target}) => this.setCustomerState({customer_recap_relevant_needs: target.value})}
							fullWidth
							minHeight={250}
							readOnly={readOnly}
						/>

						<div className="h-line spacing"/>

						<h3>Accepter</h3>

						<p className={"field-label with-previous"}>
							Hur ser kunden på det som beskrivits, känns det som att det är rätt bild av kundens situation?
						</p>

						<TextView
							name="customer_recap_correct_description"
							label={`Fritext (${1800 - customerState.customer_recap_correct_description.length} tecken kvar)`}
							value={customerState.customer_recap_correct_description}
							maxLength={1800}
							validation={value => value.length > 0}
							resize="vertical"
							onChange={({target}) => this.setCustomerState({customer_recap_correct_description: target.value})}
							fullWidth
							minHeight={250}
							readOnly={readOnly}
						/>

						<div className={"with-info-box with-margin"}>
							<div className={"inputs"}>
								<p className={"field-label"}>
									Vad skulle det innebära om vi kunde förbättra detta?
								</p>
								<TextView
									name="customer_recap_improvement"
									label={`Fritext (${1800 - customerState.customer_recap_improvement.length} tecken kvar)`}
									value={customerState.customer_recap_improvement}
									maxLength={1800}
									validation={value => value.length > 0}
									resize="vertical"
									onChange={({target}) => this.setCustomerState({customer_recap_improvement: target.value})}
									fullWidth
									minHeight={250}
									readOnly={readOnly}
								/>
							</div>
							<div className={"info-box"}>
								Om vi kunde lösa det vi har gått igenom, skulle du se det som en bättre lösning än det du har idag?
							</div>
						</div>

						<div className="h-line spacing"/>

						<h3>Delavslut</h3>
						<p className={"field-label with-previous"}>
							Om vi idag kunde presentera en lösning som kunden tror är rätt och gillar,
							finns det något som hindrar oss ifrån att gå vidare i ett samarbete?
						</p>

						<TextView
							name="customer_recap_obstacles"
							label={`Fritext (${1800 - customerState.customer_recap_obstacles.length} tecken kvar)`}
							value={customerState.customer_recap_obstacles}
							maxLength={1800}
							validation={value => value.length > 0}
							resize="vertical"
							onChange={({target}) => this.setCustomerState({customer_recap_obstacles: target.value})}
							fullWidth
							minHeight={250}
							readOnly={readOnly}
						/>

						<OptionsList
							style={{marginBottom: "0", marginTop: "15px"}}
							type="radio"
							description={"Har det hänt något sedan sist vi sågs som du tycker är viktigt att jag känner till?"}
							name="radio_customer_news_since_last"
							value={customerState.radio_customer_news_since_last}
							options={[
								{
									label: "Nej",
									value: "no",
									checked: customerState.radio_customer_news_since_last === "no"
								},
								{
									label: "Ja",
									value: "yes",
									checked: customerState.radio_customer_news_since_last === "yes"
								}
							]}
							onChange={(checked, radio_customer_news_since_last) => this.setCustomerState({radio_customer_news_since_last})}
							validation={(value) => ((value && value.length > 0) || false)}
							highlightErrors={hasFormValidationErrors}
							readOnly={readOnly}
						/>

						{customerState.radio_customer_news_since_last === "yes" && (
							<React.Fragment>
								<p className={"field-label with-previous"}>
									Berätta vad
								</p>

								<TextView
									name="radio_customer_news_since_last_details"
									label={`Fritext (${1800 - customerState.radio_customer_news_since_last_details.length} tecken kvar)`}
									value={customerState.radio_customer_news_since_last_details}
									maxLength={1800}
									validation={value => value.length > 0}
									resize="vertical"
									onChange={({target}) => this.setCustomerState({radio_customer_news_since_last_details: target.value})}
									fullWidth
									minHeight={250}
									readOnly={readOnly}
								/>
							</React.Fragment>
						)}

						<OptionsList
							style={{marginBottom: "0", marginTop: "15px"}}
							type="radio"
							description={"Har du träffat någon annan aktör sedan vi sågs?"}
							name="radio_customer_another_actor_since_last"
							value={customerState.radio_customer_another_actor_since_last}
							options={[
								{
									label: "Nej",
									value: "no",
									checked: customerState.radio_customer_another_actor_since_last === "no"
								},
								{
									label: "Ja",
									value: "yes",
									checked: customerState.radio_customer_another_actor_since_last === "yes"
								}
							]}
							onChange={(checked, radio_customer_another_actor_since_last) => this.setCustomerState({radio_customer_another_actor_since_last})}
							validation={(value) => ((value && value.length > 0) || false)}
							highlightErrors={hasFormValidationErrors}
							readOnly={readOnly}
						/>


						{customerState.radio_customer_another_actor_since_last === "yes" && (
							<React.Fragment>
								<p className={"field-label with-previous"}>
									Vad tyckte du var bra med deras förslag/presentation?
								</p>

								<TextView
									name="radio_customer_another_actor_positives"
									label={`Fritext (${1800 - customerState.radio_customer_another_actor_positives.length} tecken kvar)`}
									value={customerState.radio_customer_another_actor_positives}
									maxLength={1800}
									validation={value => value.length > 0}
									resize="vertical"
									onChange={({target}) => this.setCustomerState({radio_customer_another_actor_positives: target.value})}
									fullWidth
									minHeight={250}
									readOnly={readOnly}
								/>

								<p className={"field-label with-previous"}>
									Det är ju sällan ett förslag är perfekt, vad hade kunnat vara ännu bättre i deras förslag?
								</p>

								<TextView
									name="radio_customer_another_actor_improvements"
									label={`Fritext (${1800 - customerState.radio_customer_another_actor_improvements.length} tecken kvar)`}
									value={customerState.radio_customer_another_actor_improvements}
									maxLength={1800}
									validation={value => value.length > 0}
									resize="vertical"
									onChange={({target}) => this.setCustomerState({radio_customer_another_actor_improvements: target.value})}
									fullWidth
									minHeight={250}
									readOnly={readOnly}
								/>
							</React.Fragment>
						)}
					</div>
				</ContentBox>
			</div>
		);
	}
}

// PRIVATE FUNCTIONS
function _getInitialState()
{
	const {customer, viewNo, hasFormValidationErrors, readOnly} = this.props;
	const seenViews = JSON.parse(localStorage.getItem(`SEEN_VIEWS_${btoa(customer.caseId)}`)) || [];
	const hasBeenSeen = (seenViews.includes(viewNo));

	// if it hasn't been seen add the view to local storage for the specific case
	if (customer.caseId && !hasBeenSeen)
	{
		localStorage.setItem(`SEEN_VIEWS_${btoa(customer.caseId)}`, JSON.stringify([...seenViews, viewNo]));
	}

	let newState = getViewInitialStateForCustomer(customer);
	newState.isFulfilled = this.isFulfilled(newState);
	newState.hasFormValidationErrors = hasBeenSeen || hasFormValidationErrors;
	newState.readOnly = readOnly;
	return newState;
}

export function getViewInitialStateForCustomer(customer)
{
	return {
		isFulfilled: false,
		isLoading: true,
		lookupNotFound: false,
		fraudFlag: false,
		errorMessage: null,
		customerState: {
			customer_recap_relevant_needs: customer.getData("customer_recap_relevant_needs", ""),
			customer_recap_correct_description: customer.getData("customer_recap_correct_description", ""),
			customer_recap_improvement: customer.getData("customer_recap_improvement", ""),
			customer_recap_obstacles: customer.getData("customer_recap_obstacles", ""),
			radio_customer_news_since_last: customer.getData("radio_customer_news_since_last", ""),
			radio_customer_news_since_last_details: customer.getData("radio_customer_news_since_last_details", ""),
			radio_customer_another_actor_since_last: customer.getData("radio_customer_another_actor_since_last", ""),
			radio_customer_another_actor_positives: customer.getData("radio_customer_another_actor_positives", ""),
			radio_customer_another_actor_improvements: customer.getData("radio_customer_another_actor_improvements", ""),
		}
	};
}

function _getFields()
{
	return [
		"customer_recap_relevant_needs",
		"customer_recap_correct_description",
		"customer_recap_improvement",
		"customer_recap_obstacles",
		"radio_customer_news_since_last",
		"radio_customer_news_since_last_details",
		"radio_customer_another_actor_since_last",
		"radio_customer_another_actor_positives",
		"radio_customer_another_actor_improvements",
	];
}